// test1596
(1596 && 0);
